import(/* webpackMode: "eager" */ "/codebuild/output/src1053796749/src/doctor-dashboard/app/[locale]/(commonAuthenticatedLayout)/page.tsx");
